import { render } from "./sitemap-propertytypes.vue?vue&type=template&id=2c8e717a"
import script from "./sitemap-propertytypes.js?vue&type=script&lang=js"
export * from "./sitemap-propertytypes.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__